import React from 'react';
import zxcvbn from 'zxcvbn';
import { ProgressBar } from '@99designs/emu';
import { colors } from '@99designs/emu/settings';

export interface PasswordStrengthBarProps {
    password: string;
}

function calculateScorePercent(score: number, password: string) {
    if (score === 0 && password.length > 0) {
        return 10;
    }
    return score * 25;
}

export function PasswordStrengthBar({ password }: PasswordStrengthBarProps) {
    const scorePercent = calculateScorePercent(zxcvbn(password).score, password);

    let background, color;
    if (scorePercent === 100) {
        background = colors.mildredsCar;
        color = colors.forrestLyf;
    } else if (scorePercent >= 50) {
        background = colors.sandyButt;
        color = colors.heritage;
    } else if (scorePercent > 0) {
        background = colors.littlePiggy;
        color = colors.risingSun;
    }

    // eslint-disable-next-line @nrwl/nx/workspace/ui-progressbar-require-a11y-name
    return <ProgressBar progress={scorePercent} background={background} color={color} small />;
}
